import React from 'react';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { chevronDownIcon } from '@progress/kendo-svg-icons';
import { useCurrentUserContext, useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { CpsIndex } from '@cs-cms/types';

export const IndexDropdown: React.FC = () => {
  const { currentUser, selectedIndex, setSelectedIndex } = useCurrentUserContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <>
      {currentUser?.indexes && currentUser.indexes.length > 1 && (
        <DropDownList
          svgIcon={chevronDownIcon}
          title={selectedIndex?.displayName}
          label={translate('custom.toolbar.index')}
          data={currentUser.indexes}
          textField={'displayName'}
          dataItemKey="id"
          value={selectedIndex}
          fillMode="solid"
          onChange={(event: DropDownListChangeEvent) => {
            if (setSelectedIndex && event.value) {
              setSelectedIndex(event.value as CpsIndex);
            }
          }}
        />
      )}
    </>
  );
};
